var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('FormButton',{staticClass:"play-btn",on:{"click":_vm.onPlay}},[_vm._v(" Play ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }